import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { selectAllCalls, selectCallsState } from '../../../state/call/current-call.selector';
import { CallEntry } from '../../../state/call/current-call-state';

@Component({
    selector: 'app-call-state-debug-card',
    templateUrl: './call-state-debug-card.component.html',
    styleUrl: './call-state-debug-card.component.scss'
})
export class CallStateDebugCardComponent implements OnInit, OnDestroy {

    calls: CallEntry[] = [];
    activeCallId: string | null = null;

    // Drag state
    isDragging = false;
    position = { x: 20, y: 20 };
    private dragOffset = { x: 0, y: 0 };

    private destroy$ = new Subject<void>();

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.store.select(selectAllCalls).pipe(
            takeUntil(this.destroy$)
        ).subscribe(calls => {
            this.calls = calls;
        });

        this.store.select(selectCallsState).pipe(
            takeUntil(this.destroy$)
        ).subscribe(state => {
            this.activeCallId = state.activeCallId;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    // Per-call state helpers
    isIdle(call: CallEntry): boolean {
        return !call.mainLeg && !call.pipLeg;
    }

    isIncoming(call: CallEntry): boolean {
        return call.mainLeg?.status === 'incoming' && !call.pipLeg;
    }

    isOutgoing(call: CallEntry): boolean {
        return call.mainLeg?.status === 'outgoing' && !call.pipLeg;
    }

    isSpeaking(call: CallEntry): boolean {
        return call.mainLeg?.status === 'speaking' && !call.pipLeg;
    }

    isOnHold(call: CallEntry): boolean {
        return call.pipLeg?.status === 'hold' && !call.mainLeg;
    }

    isForwarding(call: CallEntry): boolean {
        return call.pipLeg?.status === 'hold' && call.mainLeg != null;
    }

    stateLabel(call: CallEntry): string {
        if (this.isIdle(call)) return 'IDLE';
        if (this.isIncoming(call)) return 'INCOMING';
        if (this.isOutgoing(call)) return 'CALLING';
        if (this.isSpeaking(call)) return 'SPEAKING';
        if (this.isOnHold(call)) return 'ON HOLD';
        if (this.isForwarding(call)) return 'FORWARDING';
        return 'UNKNOWN';
    }

    stateClass(call: CallEntry): string {
        if (this.isIdle(call)) return 'debug-state-idle';
        if (this.isIncoming(call)) return 'debug-state-incoming';
        if (this.isOutgoing(call)) return 'debug-state-outgoing';
        if (this.isSpeaking(call)) return 'debug-state-speaking';
        if (this.isOnHold(call)) return 'debug-state-hold';
        if (this.isForwarding(call)) return 'debug-state-forwarding';
        return 'debug-state-idle';
    }

    // Drag handlers (right/bottom positioning)
    onMouseDown(event: MouseEvent): void {
        this.isDragging = true;
        this.dragOffset = {
            x: (window.innerWidth - event.clientX) - this.position.x,
            y: (window.innerHeight - event.clientY) - this.position.y
        };
        event.preventDefault();
    }

    onMouseMove(event: MouseEvent): void {
        if (!this.isDragging) return;

        this.position = {
            x: (window.innerWidth - event.clientX) - this.dragOffset.x,
            y: (window.innerHeight - event.clientY) - this.dragOffset.y
        };
    }

    onMouseUp(): void {
        this.isDragging = false;
    }
}
